import { getUserLogin } from 'containers/User/service';
import invariant from 'invariant';
import React, { useContext, useState } from 'react';
import { removeHKS, setHKS } from 'utils/HKS';
import LaunchRedirect from 'utils/LaunchRedirect';
import { store } from 'store';
import { useDispatch, useSelector } from 'react-redux';
import { execSafePushSession } from 'utils/getStickySession';
import * as actions from 'actions/response';
import { useNavigate, useLocation } from 'react-router-dom';
import { ANONYMOUS_USER, GetRegion } from 'constants.js';
import Utils from 'utils/Utils';
import _ from 'lodash';
import { useCheckoutRedirect } from 'containers/Payment/hooks/useCheckoutRedirect';
import { get, set } from 'utils/LocalStorageUtil';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';
import BootstrapContext from 'context/BootstrapContext';
import { GET_POPULAR_SEARCHES } from 'containers/NewSearchPage/redux/constants';
import Metrics from 'services/metrics';
import getFirstNode from 'utils/getFirstNode';
import { getRegion } from 'utils/Region';
import { logoutService } from 'api/services/user/logout';
import { logoutSession } from 'containers/MusicPage/actions';
import {
  hideProfileLoader,
  showProfileLoader,
} from 'containers/ProfileManager/redux/profile.actions';
import { fetchUserSubscriptions, setProfile } from 'action-creators/user';

const useHandleUserProvider = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const claroLiteConfig = useSelector(state => getClaroAdsKey(state));
  const { handleRedirectCheckoutFromFreemium } = useCheckoutRedirect();
  const bootstrapContext = useContext(BootstrapContext);
  const [changeReady, setChangeReady] = useState(false);
  const [userModel, setUserModel] = useState(null);
  const firstNode = getFirstNode(claroLiteConfig);
  const ERROR_CODE_TERMS_NOT_ACCEPTED = 'accept_terms';

  const logOutApp = async (params = {}) => {
    const region = getRegion();
    setChangeReady(false);
    await logoutService(params);
    removeHKS();
    localStorage.clear();
    // updateNewRelicParams();
    localStorage.setItem('logOutForce', 'actived');
    store.dispatch(logoutSession());

    await bootstrapContext.reboot(() => {});
    store.dispatch({
      type: 'CLEARUSER',
      user: {
        userType: ANONYMOUS_USER,
        is_user_logged_in: 0,
      },
    });
    return window.location.assign('/');
  };
  const redirectDeepLink = () => {
    const logged = localStorage.getItem('loginInfo.logged_user');
    let urlIpTelmex = JSON.parse(
      localStorage.getItem('ipTelmexPromotion') || '{}',
    );
    urlIpTelmex = urlIpTelmex || {};

    if (urlIpTelmex.lit) {
      if (logged === 'true') {
        const info = JSON.parse(
          localStorage.getItem('loginInfo.logged_user_data') || '{}',
        );

        if (info?.profile?.paymentMethods[0]?.gateway === 'telmexmexicogate') {
          if (
            ((urlIpTelmex.urlPromotion &&
              urlIpTelmex.urlPromotion !== '' &&
              urlIpTelmex.urlPromotion !== urlIpTelmex.urlLastPromotion) ||
              (urlIpTelmex.urlInitSession &&
                urlIpTelmex.urlPromotion !== urlIpTelmex.urlLastPromotion)) &&
            urlIpTelmex.lit
          ) {
            urlIpTelmex.urlPromotion =
              urlIpTelmex.urlNotSession !== '' &&
              urlIpTelmex.urlNotSession !== undefined
                ? urlIpTelmex.urlNotSession
                : urlIpTelmex.urlPromotion;
            urlIpTelmex.urlPromotion =
              urlIpTelmex.urlInitSession !== '' &&
              urlIpTelmex.urlInitSession !== undefined
                ? urlIpTelmex.urlInitSession
                : urlIpTelmex.urlPromotion;

            urlIpTelmex.lit = false;
            urlIpTelmex.urlLastPromotion = urlIpTelmex.urlPromotion;
            urlIpTelmex.urlPromotion = '';
            urlIpTelmex.urlNotSession = '';
            urlIpTelmex.urlInitSession = '';
            localStorage.setItem(
              'ipTelmexPromotion',
              JSON.stringify(urlIpTelmex),
            );

            window.location = urlIpTelmex.urlLastPromotion;
          }
        }
      }
    } else if (
      Utils.isDeepLink(window.location.href) &&
      window.location.href.includes('&playerHtml5')
    ) {
      window.location = Utils.createDeepLinkToPlayer(window.location);
    }
  };
  const updateHksInSHI = HKS => {
    const currentSHI = JSON.parse(
      localStorage.getItem('startHeaderInfoResponse') || '{}',
    );
    currentSHI.response.session_stringvalue = HKS;
    localStorage.setItem('startHeaderInfoResponse', JSON.stringify(currentSHI));
  };

  const checkUserLogin = cb => {
    if (bootstrapContext.configModel !== null)
      Utils.checkLogin(
        { config: bootstrapContext.configModel },
        user => {
          setUserModel(user);
          setChangeReady(true);
          redirectDeepLink();
          window.utils.userType.checkType();
          cb && cb(user);
        },
        navigate,
      );
  };

  const loginApp = async (response, nextActions, isIpTelmex = false) => {
    setChangeReady(false);
    const resp = await execSafePushSession(response);
    dispatch(hideProfileLoader());
    if (resp.status !== 200) {
      dispatch(actions.removeModal('RetryPushSession'));
      dispatch(
        actions.showModal({
          modalType: 'RetryPushSession',
          props: {
            message: window.utils.getMeta.translations(
              _.get(resp, 'code', 'PGS-CHM-00001'),
            ),
            onRetry: () => navigate(`/${GetRegion()}/login`, { replace: true }),
          },
        }),
      );
      setChangeReady(true);
    } else {
      updateHksInSHI(response.session_stringvalue);
      setHKS(response.session_stringvalue);
      // eslint-disable-next-line no-underscore-dangle

      Utils.__setLoggedUserData(
        response,
        () => {
          redirectDeepLink();
          window.utils.userType.checkType();
          const acceptTerms = Number(_.get(response, 'accepted_terms'));
          const errors = _.get(response, 'errors', {});

          // Here you should place the logic to redirect to profile pages
          if (typeof nextActions === 'function') {
            nextActions();
          } else if (
            acceptTerms === 0 &&
            errors?.code === ERROR_CODE_TERMS_NOT_ACCEPTED
          ) {
            set('loginInfo.acceptedTerms', 0);
            navigate(`/${GetRegion()}/terms`);
          } else if (
            !_.isNil(searchParams.get('group_id')) ||
            !_.isNil(searchParams.get('prepago')) ||
            !_.isNil(searchParams.get('linkworkflowstart'))
          ) {
            claroLiteConfig
              ? handleRedirectCheckoutFromFreemium()
              : navigate({
                  pathname: `/${GetRegion()}/payment`,
                  search: searchParams.toString(),
                });
          } else {
            const vcardRedirect =
              localStorage.getItem('anonymousUserComeFromPlayer') &&
              localStorage.getItem('urlVcard');
            const selectFirst = get('selectProfile');
            if (selectFirst) {
              navigate({
                pathname: `/${GetRegion()}/${
                  vcardRedirect ? 'payment' : firstNode
                }`,
                search: searchParams.toString(),
              });
            }
            const isForgettenPassword = location?.pathname?.includes(
              'forgottenPassword',
            );
            if (isForgettenPassword) LaunchRedirect(claroLiteConfig, navigate);
          }

          if (bootstrapContext.configModel !== null) {
            Utils.checkLogin(
              { config: bootstrapContext.configModel },
              user => {
                dispatch(hideProfileLoader());
                dispatch(setProfile(user.profile));
                setUserModel(user);
                setChangeReady(true);
              },
              navigate,
            );
          }
        },
        isIpTelmex,
      );
    }
  };

  const handleChangeProfile = async (
    userhash,
    members = [],
    adminId = null,
    fromModalProfile = false,
  ) => {
    setChangeReady(false);
    dispatch(showProfileLoader());
    let result = {};
    try {
      result = await getUserLogin({
        userhash,
      });
      const { response, error } = result;
      setHKS(response.session_stringvalue);
      updateHksInSHI(response.session_stringvalue);
      invariant(error === undefined, 'Error at login new profile');
      if (members.length > 0 && adminId) {
        const userSelected = _.find(members, { user_hash: userhash });
        Metrics.newEvent({
          PID: `${userSelected.partnerUserId}${adminId}`,
        });
      }

      // consumimos suscripciones de nuevo servicio
      const { subscriptions, paymentMethods } = await dispatch(
        fetchUserSubscriptions(result?.response?.user_token),
      );

      loginApp(
        {
          ...response,
          subscriptions,
          paymentMethods,
          paywayProfile: {
            subscriptions,
            paymentMethods,
          },
        },
        () => {
          const selectFirst = get('selectProfile');
          const isFreemiumNotLogged = localStorage.getItem('object_id');
          const anonymousUser =
            fromModalProfile && window.location.href.includes('vcard');
          dispatch({
            type: GET_POPULAR_SEARCHES,
            payload: [],
          });
          if (selectFirst && !anonymousUser && !isFreemiumNotLogged) {
            return LaunchRedirect(claroLiteConfig, navigate);
          }

          localStorage.removeItem('fromProfile');
          localStorage.removeItem('object_id');
          setChangeReady(true);
          dispatch(hideProfileLoader());
        },
      );
    } catch (err) {
      setChangeReady(true);
      dispatch(hideProfileLoader());
      store.dispatch(
        actions.showModal({
          modalType: 'ErrorSimple',
          props: {
            message: window.utils.getMeta.translations(
              _.get(result, 'error.code', 'PGS-CHM-00001'),
            ),
          },
        }),
      );
    }
  };

  return {
    handleChangeProfile,
    updateHksInSHI,
    redirectDeepLink,
    loginApp,
    changeReady,
    setChangeReady,
    userModel,
    setUserModel,
    checkUserLogin,
    logOutApp,
  };
};

export default useHandleUserProvider;
